import * as React from "react";
import {Option} from "ts-option";
import Job from "../../../model/job/Job";
import {Dispatch} from "redux";
import {editJob} from "../../../store/action/job/job";
import Toast from "../../helper/Toast";
import {connect} from "react-redux";
import {AssetsSerialNumbers} from "./AssetsSerialNumbers";
import SerialNumbersData from "../../../model/job/SerialNumbersData";

interface IComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface IDispatchProps {
	/**
	 * Edit job action.
	 * @param {Job} job
	 */
	editJob: (job: Job) => void;
}

type Props = IComponentProps & IDispatchProps

class JobAssetsSerialNumbers extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<AssetsSerialNumbers serialNumbers={this.props.job.flatMap(j => j.data.serialNumbers)} onChange={this.onChange}/>
		);
	}

	onChange(serialNumbers: Option<SerialNumbersData>) {
		this.props.job.map(j => {
			const updatedJob = j.copy({data: j.data.copy({serialNumbers})});
			this.props.editJob(updatedJob)
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editJob: (job: Job) => dispatch(
			editJob(
				job,
				() => Toast.success("Job assets serial numbers updated", "Job details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Job details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(JobAssetsSerialNumbers)